/**
 * Created by Abner Sui on 05/15/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

export enum EmailDigestSubChromeEventTypes {
    SAVE = 'SAVE',
    CANCEL = 'CANCEL',
}
